import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/PublicPromoCode`;

const PublicPromoCode = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllUsedPromoCodeByUser: (params) => {
    const url = `${baseServiceUrl}/getAllUsedPromoCodeByUser`;
    return ServiceApi.get(url, { params });
  },

  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getAllPromoCategory: () => {
    const url = `${baseServiceUrl}/getAllPromoCategory`;
    return ServiceApi.get(url);
  },
  getAgentById: (params) => {
    const url = `${baseServiceUrl}/getAgentById?id=` + params;
    return ServiceApi.get(url, { params });
  },
  createandEditPublicPromoCode: (params) => {
    const url = `${baseServiceUrl}/addOrEditPublicPromoCode`;
    return ServiceApi.post(url, params);
  },
  getNewPromoCodeQuery: () => {
    const url = `${baseServiceUrl}/getNewPromoCodeQuery`;
    return ServiceApi.get(url);
  },
  removePublicPromoCode: (params) => {
    const url = `${baseServiceUrl}/removePublicPromoCode`;
    return ServiceApi.put(url, params);
  },

};

export default PublicPromoCode;


